const steps = [
  {
    step: "01",
    icon: "ri-edit-line",
    title: "输入描述",
    description: "用文字描述你想要的AI美女形象，包括发型、风格、场景等细节。",
  },
  {
    step: "02",
    icon: "ri-settings-3-line",
    title: "选择风格",
    description: "从写真、头像、壁纸、虚拟角色等多种风格中选择你的创作方向。",
  },
  {
    step: "03",
    icon: "ri-flashlight-line",
    title: "AI生成",
    description: "点击生成按钮，AI将在数秒内为你创作出精美的美女图像。",
  },
  {
    step: "04",
    icon: "ri-download-2-line",
    title: "下载使用",
    description: "满意后即可高清下载，用作头像、壁纸或社交媒体分享。",
  },
];

export default function HowItWorks() {
  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 text-xs font-medium bg-primary-100 text-primary-700 rounded-full mb-4">
            操作流程
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            四步轻松创作AI美女
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto leading-relaxed">
            无需任何设计基础，只需简单四步，即可拥有专属AI美女图像。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((s, idx) => (
            <div key={s.step} className="relative text-center">
              {idx < steps.length - 1 && (
                <div className="hidden lg:block absolute top-12 left-[60%] w-[80%] h-px border-t-2 border-dashed border-secondary-200"></div>
              )}
              <div className="w-16 h-16 mx-auto mb-5 flex items-center justify-center rounded-2xl bg-primary-100/70 text-primary-600">
                <i className={`${s.icon} text-2xl`}></i>
              </div>
              <span className="inline-block text-xs font-bold text-primary-400 mb-3">
                {s.step}
              </span>
              <h3 className="text-lg font-heading font-semibold text-foreground-950 mb-3">
                {s.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {s.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}